<template>
  <div class="withdraw-container">
    <section class="withdraw__section">
      <div v-if="!isApp" class="withdraw__head-wrapper">
        <PageHeadline class="withdraw__head" title="退会にあたって" />
      </div>
      <div class="withdraw__body">
        <div class="withdraw__attention-wrapper">
          <div class="withdraw__attention-container">
            <div class="withdraw__attention--body">
              <DecorationSubTitle
                class="withdraw__attention--title"
                text="ご注意ください"
                :heading-level="2"
              />
              <div class="withdraw__attention--section">
                <DecorationSubTitleSmall
                  class="withdraw__attention--sub-title"
                  text="削除されたデータは、元に戻せません"
                  :heading-level="3"
                />
                <div class="withdraw__attention--description-area">
                  <p class="module-text">
                    退会手続きをされますと、gifteeアカウントが削除され、ログインできなくなります。
                  </p>
                  <p class="module-text">
                    退会後にアカウントを元に戻すことはできませんのでご注意ください。
                  </p>
                </div>
              </div>
              <div class="withdraw__attention--section">
                <DecorationSubTitleSmall
                  class="withdraw__attention--sub-title"
                  text="ギフトカードを一覧で確認できなくなります"
                  :heading-level="3"
                />
                <div class="withdraw__attention--description-area">
                  <p class="module-text">
                    退会手続きをされますと、受け取ったギフトカードやメッセージを、一覧で確認することができなくなります。
                  </p>
                </div>
                <div class="withdraw__attention--btn-area">
                  <button
                    class="btn-multi btn-multi--single chevron--forward--black"
                    @click="onClickReceivedGiftLinkButton"
                  >
                    受け取りログを確認する
                  </button>
                </div>
                <div class="withdraw__attention--description-area">
                  <p class="module-text">
                    また、退会後も有効期限内のギフト受け取りは可能ですので、該当のギフトをお持ちの場合、
                    ギフトカードのURLが分からなくならないようご注意ください。
                  </p>
                </div>
                <div class="withdraw__attention--btn-area">
                  <button
                    class="btn-multi btn-multi--single chevron--forward--black"
                    @click="onClickUsableGiftLinkButton"
                  >
                    使えるギフトを確認する
                  </button>
                </div>
              </div>
              <div class="withdraw__attention--section">
                <DecorationSubTitleSmall
                  class="withdraw__attention--sub-title"
                  text="登録済みのギフトコードは利用できなくなります"
                  :heading-level="3"
                />
                <div class="withdraw__attention--description-area">
                  <p class="module-text">
                    退会手続きをされますと、既にアカウントに登録されたギフトコードは利用できなくなります。
                    利用可能なギフトコードがないか、今一度ご確認ください。
                  </p>
                </div>
                <div class="withdraw__attention--btn-area">
                  <button
                    class="btn-multi btn-multi--single chevron--forward--black"
                    @click="onClickGiftCodeLinkButton"
                  >
                    ギフトコードを確認する
                  </button>
                </div>
              </div>
              <div class="withdraw__attention--section">
                <DecorationSubTitleSmall
                  class="withdraw__attention--sub-title"
                  text="退会手続き後もgifteeからお知らせメールが届くことがあります"
                  :heading-level="3"
                />
                <div class="withdraw__attention--description-area">
                  <p class="module-text">
                    退会手続きの反映には一定時間がかかり、反映が完了するまでの間はgifteeからのメールが届くことがありますのでご了承ください。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="withdraw__foot-content-wrapper">
          <div class="withdraw__form-container">
            <div class="withdraw__form--description-area">
              <span class="caption-black">
                上記の内容を確認の上、退会ボタンを押してください
              </span>
            </div>
            <form action="/user" method="post" @submit="onSubmit">
              <div class="withdraw__form--checkbox-area">
                <label
                  :class="{
                    checkbox: !isAgreement,
                    'checkbox--checked': isAgreement
                  }"
                >
                  <input v-model="isAgreement" type="checkbox" />
                  <span class="module-text">確認しました</span>
                </label>
              </div>
              <input type="hidden" name="_method" value="DELETE" />
              <input
                type="hidden"
                name="authenticity_token"
                :value="authenticityToken"
              />
              <div class="withdraw__form--submit-btn-area">
                <button
                  class="btn btn--primary"
                  :disabled="disableSubmitButton"
                >
                  退会する
                </button>
              </div>
            </form>
          </div>
          <div v-if="!isApp" class="withdraw__top-link-area">
            <a href="/" class="text-link-to-top">gifteeトップへ戻る</a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import PageHeadline from '../../molecules/headlines/PageHeadline'
import DecorationSubTitle from '../../atoms/decoration/DecorationSubTitle'
import DecorationSubTitleSmall from '../../atoms/decoration/DecorationSubTitleSmall'
export default {
  components: {
    DecorationSubTitleSmall,
    DecorationSubTitle,
    PageHeadline
  },
  props: {
    authenticityToken: {
      type: String,
      required: true
    },
    isApp: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isAgreement: false,
      submittable: true
    }
  },
  computed: {
    disableSubmitButton() {
      return !this.isAgreement || !this.submittable
    }
  },
  methods: {
    onSubmit() {
      this.submittable = false
    },
    onClickReceivedGiftLinkButton() {
      window.location.href = '/mypage/received_logs'
    },
    onClickUsableGiftLinkButton() {
      window.location.href = '/mypage/gifts'
    },
    onClickGiftCodeLinkButton() {
      window.location.href = '/mypage/gift_codes'
    }
  }
}
</script>
<style lang="scss" scoped>
.withdraw-container {
  background-color: $gray-3;
  margin: 0 auto;
}

.withdraw {
  &__head-wrapper {
    background-color: $white;
    margin-bottom: 16px;
  }

  &__attention-wrapper {
    background-color: $white;
    margin-bottom: 16px;
  }

  &__attention-container {
    max-width: $base-contents-width;
    margin: 0 auto;
    padding: 20px 0;
    text-align: left;

    :last-child {
      margin-bottom: 0;
    }
  }

  &__attention {
    &--body {
      padding: 0 16px;
    }

    &--title {
      margin-bottom: 24px;
    }

    &--sub-title {
      margin-bottom: 24px;
    }

    &--section {
      margin-bottom: 32px;
    }

    &--description-area {
      margin-bottom: 16px;
    }

    &--btn-area {
      margin-bottom: 24px;
    }
  }

  &__foot-content-wrapper {
    background-color: $white;
  }

  &__form-container {
    margin: 0 auto;
    padding: 24px;
    max-width: $small-contents-width;
  }

  &__form {
    &--description-area {
      margin-bottom: 24px;
    }

    &--checkbox-area {
      margin-bottom: 40px;
    }

    &--submit-btn-area {
      margin-bottom: 24px;
    }
  }

  &__top-link-area {
    padding-bottom: 24px;
    display: flex;
    justify-content: center;
  }
}
</style>
